// extracted by mini-css-extract-plugin
module.exports = {"blockBgTitle":"blockBgTitle-module--blockBgTitle--TB6oM","blockBgTitle__text":"blockBgTitle-module--blockBgTitle__text--3zWeS"};